const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
const CONSENT_KEY = "nexus-consent-preferences";
const DEFAULT_PREFERENCES = { analytics: true, marketing: false };
const CONSENT_WAIT_MS = 500;

let isInitialized = false;

const getStoredConsent = () => {
  if (typeof window === "undefined") {
    return null;
  }
  try {
    const stored = window.localStorage.getItem(CONSENT_KEY);
    if (!stored) {
      return null;
    }
    const parsed = JSON.parse(stored);
    if (typeof parsed?.analytics !== "boolean" || typeof parsed?.marketing !== "boolean") {
      return null;
    }
    return { analytics: parsed.analytics, marketing: parsed.marketing };
  } catch (error) {
    return null;
  }
};

const buildConsentPayload = (preferences) => ({
  analytics_storage: preferences.analytics ? "granted" : "denied",
  ad_storage: preferences.marketing ? "granted" : "denied",
  ad_user_data: preferences.marketing ? "granted" : "denied",
  ad_personalization: preferences.marketing ? "granted" : "denied",
});

const ensureDataLayer = () => {
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    window.dataLayer.push(arguments);
  };
};

export const initGa4 = () => {
  if (isInitialized || !GA_MEASUREMENT_ID || typeof window === "undefined") {
    return;
  }
  isInitialized = true;

  ensureDataLayer();

  const storedConsent = getStoredConsent();
  const preferences = storedConsent ?? DEFAULT_PREFERENCES;

  window.gtag("consent", "default", {
    ...buildConsentPayload(preferences),
    wait_for_update: CONSENT_WAIT_MS,
  });

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  window.gtag("js", new Date());
  window.gtag("config", GA_MEASUREMENT_ID, {
    send_page_view: false,
    debug_mode: process.env.NODE_ENV !== "production",
  });
};

export const updateConsent = (preferences) => {
  if (!window?.gtag) {
    return;
  }
  window.gtag("consent", "update", buildConsentPayload(preferences));
};

export const trackPageView = (pagePath) => {
  if (!window?.gtag) {
    return;
  }
  window.gtag("event", "page_view", {
    page_path: pagePath,
  });
};

export const trackEvent = (eventName, params = {}) => {
  if (!window?.gtag) {
    return;
  }
  window.gtag("event", eventName, params);
};
